// extracted by mini-css-extract-plugin
export default {"content":"SubmittedPage_content__PUvNT","spin":"SubmittedPage_spin__ilvfC"};